// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal___2x1UP","ModalFullWidth":"Modal__ModalFullWidth___3nkew","ModalClose":"Modal__ModalClose___1-eKq"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicComponents/Modal/Modal.less
// module id = 1450
// module chunks = 0 1